"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_nvd3_component_1 = require("./lib/ng2-nvd3.component");
exports.NvD3Component = ng2_nvd3_component_1.NvD3Component;
var ng2_nvd3_module_1 = require("./lib/ng2-nvd3.module");
exports.NvD3Module = ng2_nvd3_module_1.NvD3Module;



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ng2-nvd3/build/index.js
// module id = ../../../../ng2-nvd3/build/index.js
// module chunks = 3